<template>
  <v-container class="pa-0">
    <v-layout>
      <v-flex>

        <template>
          <v-layout>
            <v-flex>
              <v-text-field v-model="searchText" label="Search" clearable prepend-inner-icon="search"
                @click:prepend-inner="onClick_search" @click:clear="onClick_clear"
                @keyup.enter="onClick_search"
                :hint="comp_list.filter(el => el.isSelected === true).length + ' selected / ' + comp_list.length"
                persistent-hint
              >
                <template v-slot:append-outer>
                  <v-btn small outline round color="blue" @click="onClick_all(true)">Select All</v-btn>
                  <v-btn small outline round color="blue" @click="onClick_all(false)">Remove All</v-btn>
                </template>
              </v-text-field>
            </v-flex>
          </v-layout>
        </template>

        <template>
          <v-layout>
            <v-flex>
              <v-list two-line>
                <v-list-tile v-for="item in comp_list" :key="item.id" @click="onClick_select(item)">
                  <v-list-tile-content>
                    <v-list-tile-title :class="{ 'blue--text': item.isSelected }">
                      {{ item.emp__full_name }} ({{ item.emp__user__username }})
                    </v-list-tile-title>
                    <v-list-tile-sub-title :class="{ 'blue--text': item.isSelected }">
                      {{ item.dept__company__name }}: {{ item.dept__name }}
                    </v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-flex>
          </v-layout>
        </template>

      </v-flex>
    </v-layout>
  </v-container>
</template>


<script>
// import TreeView from "./TreeView";

export default {
  name: "ListOption",
  props: {
    items: {
      type: Array,
      default: () => [],
      required: true
    }
  },
  components: {},
  data () {
    return {
      list: [],
      listCache: [],
      searchText: ""
    };
  },
  watch: {
    // "items": {
    //   handler: function() {        
    //     this.list = [...this.items];
    //     // this.listCache = structuredClone(this.items);
    //   },
    //   deep: true,
    //   immediate: true
    // }
  },
  methods: {
    onClick_select (item) {
      this.$emit("update_item", item);
    },
    onClick_search () {
      if (this.searchText) {
        this.$emit("searchText",this.searchText);
      }
      // let temp = [];

      // if (this.searchText) {
      //   let propertiesToSearch = ["emp__full_name", "emp__user__username", "dept__name", "dept__company__name"]

      //   temp = this.items.filter(item =>
      //     propertiesToSearch.some(prop =>
      //       item[prop] && item[prop].toLowerCase().includes(this.searchText.toLowerCase())
      //     )
      //   )
      // }
      // this.$emit("input",temp);
    },
    onClick_clear () {
      this.$emit("clear_search");
    },
    onClick_all (bln) {
      this.$emit("update_all", bln);
    }
  },
  mounted () {},
  computed: {
    comp_list: {
      get: function () {
        return this.items;
      },
      set:function(val){
        // this.$emit("input",val);
      }
    }
  }
};
</script>